'use client';

import { Footer } from '@/layout/footer/Footer';
import { Navbar } from '@/layout/navbar/Navbar';

export const MainLayout = ({ children }: { children: React.ReactNode }) => {
  return (
    <>
      <Navbar />
      <main className="main-layout-content">{children}</main>
      <Footer />
    </>
  );
};
